import { SELECTED_TEAM_COOKIE_NAME } from '@/features/team-selection/constants'
import { createCookieStore } from '@/utils/cookies/cookieStore'

export const selectedTeamCookieStore = createCookieStore(
  SELECTED_TEAM_COOKIE_NAME,
)
